<template>
  <el-drawer
    :visible.sync="drawer"
    :append-to-body="true"
    :size=" !active ? 740 : 980"
    :modal="false"
    :wrapperClosable="true"
    :before-close="handleClose"
  >
    <template slot="title">
      <span>
        <span
          :class="{ active: !active }"
          class="read"
          @click.stop="handleClick(0)"
        >修改日志</span
        >
        <span
          :class="{ active: active }"
          class="read"
          @click.stop="handleClick(1)"
        >账户流水</span
        >
      </span>
    </template>
    <div class="log-body">
      <BaseTable
        v-if="!active"
        :height="height"
        :tableData="tableData1"
        :pageIndex="pagerConfig.pageIndex"
        :pageSize="pagerConfig.pageSize"
        :loading="loading"
        @handlePageChange="handlePageChange"
        @sortChange="sortChange"
      >
        <template slot="index" slot-scope="row">
          {{ tableData1.columns.indexOf(row.scope) + 1 }}
        </template>
      </BaseTable>
      <BaseTable
        v-else
        :height="height"
        :tableData="tableData"
        :pageIndex="pagerConfig.pageIndex"
        :pageSize="pagerConfig.pageSize"
        :loading="loading"
        @handlePageChange="handlePageChange"
        @sortChange="sortChange"
      >
        <template slot="index" slot-scope="row">
          {{ tableData.columns.indexOf(row.scope) + 1 }}
        </template>
      </BaseTable>
    </div>
  </el-drawer>
</template>

<script>
import { getLogPages, getChangeRecordPages } from '@/api/client'
const BaseTable = () => import('@/components/table/BaseTable.vue')
export default {
  components: { BaseTable },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    companyId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pagerConfig: {
        pageIndex: 1,
        pageSize: 50
      },
      loading: false,
      tableData: {
        fileds: [
          {
            filed: 'createdOn',
            label: '费用日期',
            width: '160px',
            isSort: true,
            formatter: (row) =>
              row.createdOn
                ? row.createdOn.slice(0, row.createdOn.length - 3)
                : ''
          },
          {
            filed: 'operationName',
            label: '操作类型',
            width: '120px'
          },
          {
            filed: 'beforeAmount',
            label: '原余额',
            width: '120px'
          },
          {
            filed: 'operatorAmount',
            label: '发生额',
            width: '120px'
          },
          {
            filed: 'afterAmount',
            label: '变动后余额',
            width: '120px'
          },
          {
            filed: 'referenceNo',
            label: '参考号码',
            width: '150px'
          },
          {
            filed: 'operationContent',
            label: '内容描述',
            width: ''
          }
        ],
        columns: [],
        total: 0
      },
      tableData1: {
        fileds: [
          {
            filed: 'createdOn',
            label: '修改日期',
            formatter: (row) =>
              row.createdOn
                ? row.createdOn.slice(0, row.createdOn.length - 3)
                : ''
          },
          {
            filed: 'createdName',
            label: '修改人',
            width: '100px'
          },
          {
            filed: 'description',
            label: '内容'
          },
          {
            filed: 'reason',
            label: '原因'
          }
        ],
        columns: [],
        total: 0
      },
      orderByObj: {},
      height: 0,
      active: 0
    }
  },
  watch: {
    async drawer(val) {
      if (val) {
        await this.getLists(this.pagerConfig)
        this.$nextTick(() => {
          const logBody = document.querySelectorAll('.log-body')
          this.height = logBody[logBody.length - 1].offsetHeight - 100
        })
      }
    }
  },
  methods: {
    handleClick(type) {
      this.active = type
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 50
      }
      this.getLists({
        pageIndex: 1,
        pageSize: 50
      })
    },
    getLists(param) {
      param = {
        ...param,
        queryParam: { companyId: this.companyId, ...this.orderByObj }
      }
      if (this.active) {
        getLogPages(param).then((res) => {
          if (res.success) {
            this.tableData.columns = res.data.list
            this.tableData.total = res.data.total
          } else {
            this.$message.error(res.errorMessage)
          }
        })
      } else {
        getChangeRecordPages(param).then((res) => {
          if (res.success) {
            this.tableData1.columns = res.data.list
            this.tableData1.total = res.data.total
          } else {
            this.$message.error(res.errorMessage)
          }
        })
      }
    },
    sortChange(orderByObj) {
      console.log('orderByObj', orderByObj)
      this.orderByObj = {
        sortField: orderByObj.filed,
        sortBy: orderByObj.order
      }
    },
    handlePageChange(pager) {
      this.pagerConfig = {
        ...this.pagerConfig,
        ...pager
      }
      const params = {
        ...this.pagerConfig,
        ...pager
      }
      this.getLists(params)
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.read {
  color: #999999;
  cursor: pointer;
  & + .read {
    margin-left: 30px;
  }
}
.active {
  color:  rgb(18,88,188);
}
.log-body {
  width: calc(100% - 40px);
  height: 100%;
  margin: 20px auto 0;
}
</style>
